import React, { Component } from 'react'
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Select from 'react-select';
import { connect } from 'react-redux'
import { api } from "../../../../../../api/index"
import TimePickerDialog from "material-ui/TimePicker/TimePickerDialog";
import DatePickerDialog from "material-ui/DatePicker/DatePickerDialog";
import {config} from "../../../../../../config";
import axios from "axios/index";
import {loadImages, resetImages} from "../../../../../../api/images";
import {getTopics} from "../../../../../../api/topics";


class PromotionGeneralAcademyCardComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoadingPosts: false,
			categories: [],
			productTypes: [
				{
					value: null,
					label: 'Maak keuze',
				},
				{
					value: 'online-cursus',
					label: 'Online Cursus',
				},
				{
					value: 'opleiding',
					label: 'Opleiding',
				},
				{
					value: 'training',
					label: 'Training',
				},
			]
		};

		this.handlePositionFieldState = this.handlePositionFieldState.bind(this);
		this.handleProductTypeChange = this.handleProductTypeChange.bind( this );
		this.renderProductTypes = this.renderProductTypes.bind( this );
		this.getCategories = this.getCategories.bind( this );
		this.renderCategories = this.renderCategories.bind(this);
	}

	async componentDidMount() {
		await this.getCategories();

		resetImages().then( () => {
			loadImages([
				{
					width: 767,
					height: 431,
				}
			]);
		});

		getTopics();
	}

	setSearchQuery(value) {
		api.promotions.handleState('postIds', value);
	}

	getPosts(input, callback) {
		let cancel;

		if ( input.length < 4 ) {
			return;
		}

		return axios.get(config.postSearch.url + '?s=' + input, )
			.then( ( response ) => {
				return new Promise((resolve, reject) => {
					let i = 0;
					let options = [];

					if (response.data.length > 0) {
						response.data.map((item) => {

							let obj = {
								ID: item.ID,
								post_title: item.post_title
							};

							options.push(obj);

							if (options.length === response.data.length) {
								resolve(options);
							}
						})
					} else {
						resolve(options);
					}


				}).then(options => {
					return {
						options: options
					};

				})
			})
	}

	handlePositionFieldState(event) {

		const target = event.target;
		const name = target.name;
		const value = target.value;

		api.promotions.handlePositionFieldState( name, value, this.props.periodKey, this.props.variantKey );
	}

	async getCategories() {
		const categories = await api.categories.get();

		this.setState({
			categories: categories,
		});
	}

	renderTopics() {
		const { topics } = this.props;

		topics.data.sort(function(a,b) {return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);} );

		return topics.data.map( ( topic, index ) =>
			<MenuItem key={index} value={topic.key} primaryText={topic.name} />
		)
	}

	renderProductTypes() {
		return this.state.productTypes.map( ( productType, index ) =>
			<MenuItem key={index} value={productType.value} primaryText={productType.label} />
		)
	}

	renderCategories() {
		return this.state.categories
			.sort( ( a, b ) => a.label.localeCompare(b.label) )
			.map( ( category, index ) => <MenuItem key={index} value={category.id} primaryText={category.label} /> )
	}

	handleProductTypeChange(event, index, value) {
		api.promotions.handleState( 'productType', value);
	}

	handleCategoryChange( event, index, value ) {
		api.promotions.handleState( 'categoryIds', value);
	}

	render() {
		return (
			<div className="grid-x grid-margin-y grid-margin-x">
			 	<div className="medium-6 cell">
			 		<label>
			 			Koppelen aan clusters
						<SelectField
							floatingLabelText="Clusters"
							value={this.props.promotion.categoryIds}
							fullWidth={true}
							onChange={this.handleCategoryChange}
							multiple={true}
						>
							{this.renderCategories()}
						</SelectField>
			 		</label>
			 	</div>
				<div className="medium-6 cell">
					<label>
						Koppelen aan product type
						<SelectField
							floatingLabelText="Product type"
							value={this.props.promotion.productType}
							fullWidth={true}
							onChange={this.handleProductTypeChange}
							multiple={false}
						>
							{this.renderProductTypes()}
						</SelectField>
					</label>
				</div>
			</div>
		);
	}
}

const mapStateToProps = ( state ) => {
	return {
		promotion: state.promotion,
		topics: state.topics
	}
};

export default connect(mapStateToProps, {
	loadImages,
	resetImages,
	getTopics
})(PromotionGeneralAcademyCardComponent)


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/types/general/academyCard.js